// extracted by mini-css-extract-plugin
export default {"paymentSection":"i1-z"};